import React from 'react';
import { PermissoesProvider } from './contexts/PermissoesContext';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/locale/pt_BR';
import MainLayout from './layouts/MainLayout';
import Calibracoes from './pages/Calibracoes';
import EnsaioLP from './pages/EnsaioLP';
import InspecaoExterna from './pages/InspecaoExterna';
import InspecaoTubulacao from './pages/InspecaoTubulacao';
import InspecaoTanque from './pages/InspecaoTanque';
import InspecaoCamara from './pages/InspecaoCamara';
import InspecaoEspessura from './pages/InspecaoEspessura';
import TesteHidrostatico from './pages/TesteHidrostatico';
import LaudoAvulso from './pages/LaudoAvulso';
import TesteEstanqueidade from './pages/TesteEstanqueidade';
import ManutencaoAutoclave from './pages/ManutencaoAutoclave';
import Clientes from './pages/Clientes';
import ClienteDetalhe from './pages/ClienteDetalhe';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Configuracoes from './pages/Configuracoes';
import SegurancaConta from './pages/SegurancaConta';
import MeuPerfil from './pages/MeuPerfil';
import Propostas from './pages/Propostas';
import Leads from './pages/Leads';
import Gestao from './pages/Gestao';
import Fiscal from './pages/Fiscal';
import Produtos from './pages/Produtos';
import Estoque from './pages/Estoque';
import PropostaProduto from './pages/PropostaProduto';
import ClassificacaoNR13 from './pages/ClassificacaoNR13';
import EnviosMassa from './pages/EnviosMassa';
import Assinar from './pages/Assinar';
import PropostaDetalhe from './pages/PropostaDetalhe';
import PropostaEditar from './pages/PropostaEditar';
import Templates from './pages/Templates';
import Laudos from './pages/Laudos';
import Agendamentos from './pages/Agendamentos';
import Usuarios from './pages/Usuarios';
import Portal from './pages/Portal';
import PortalLogin from './pages/PortalLogin';
import LaudoForm from './pages/LaudoForm';
import Relatorios from './pages/Relatorios';
import 'antd/dist/reset.css';

const RotaProtegida = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" />;
  return children;
};

function App() {
  return (
    <PermissoesProvider>
    <ConfigProvider locale={ptBR} theme={{ token: { colorPrimary: '#1a3c5e', borderRadius: 8 } }}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/portal/login" element={<PortalLogin />} />
          <Route path="/assinar/:token" element={<Assinar />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/" element={<RotaProtegida><MainLayout /></RotaProtegida>}>
            <Route index element={<Navigate to="/dashboard" />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="clientes/:id" element={<ClienteDetalhe />} />
            <Route path="propostas" element={<Propostas />} />
            <Route path="propostas/nova" element={<PropostaEditar />} />
            <Route path="propostas/:id" element={<PropostaDetalhe />} />
            <Route path="propostas/:id/editar" element={<PropostaEditar />} />
            <Route path="laudos" element={<Laudos />} />
            <Route path="relatorios" element={<Relatorios />} />
            <Route path="calibracoes" element={<Calibracoes />} />
            <Route path="calibracoes/:id" element={<Calibracoes />} />
            <Route path="ensaios-lp/:id" element={<EnsaioLP />} />
            <Route path="inspecoes-externas/:id" element={<InspecaoExterna />} />
            <Route path="inspecoes-tubulacao/:id" element={<InspecaoTubulacao />} />
            <Route path="inspecoes-tanque/:id" element={<InspecaoTanque />} />
            <Route path="inspecoes-camara/:id" element={<InspecaoCamara />} />
            <Route path="inspecoes-espessura/:id" element={<InspecaoEspessura />} />
            <Route path="testes-hidrostaticos/:id" element={<TesteHidrostatico />} />
            <Route path="testes-estanqueidade/:id" element={<TesteEstanqueidade />} />
            <Route path="manutencao-autoclave/:id" element={<ManutencaoAutoclave />} />
            <Route path="laudos-avulsos/:id" element={<LaudoAvulso />} />
            <Route path="agendamentos" element={<Agendamentos />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="fiscal" element={<Fiscal />} />
            <Route path="produtos" element={<Produtos />} />
            <Route path="estoque" element={<Estoque />} />
            <Route path="propostas-produtos/novo" element={<PropostaProduto />} />
            <Route path="propostas-produtos/:id" element={<PropostaProduto />} />
            <Route path="classificacao-nr13" element={<ClassificacaoNR13 />} />
            <Route path="envios-massa" element={<EnviosMassa />} />
            <Route path="laudos/novo" element={<LaudoForm />} />
            <Route path="laudos/:id" element={<LaudoForm />} />
            <Route path="laudos/:id/editar" element={<LaudoForm />} />
            <Route path="templates" element={<Templates />} />
            <Route path="configuracoes" element={<Configuracoes />} />
            <Route path="seguranca" element={<SegurancaConta />} />
            <Route path="perfil" element={<MeuPerfil />} />
            <Route path="leads" element={<Leads />} />
            <Route path="gestao" element={<Gestao />} />
          </Route>
        </Routes>
      </Router>
    </ConfigProvider>
    </PermissoesProvider>
  );
}

export default App;
